import { apiService } from './apiService';

export const generalList2Service = {
  async getAll(params?: { status?: string; shipmentId?: string; updatedSince?: string; includeLocked?: boolean }) {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.shipmentId) queryParams.append('shipmentId', params.shipmentId);
    if (params?.updatedSince) queryParams.append('updatedSince', params.updatedSince);
    if (params?.includeLocked) queryParams.append('includeLocked', '1');

    const query = queryParams.toString();
    return await apiService.get(`/general-list-2-records${query ? `?${query}` : ''}`, { timeoutMs: 300000 });
  },

  async getDriverActiveShipments(driverId: string) {
    return await apiService.get(`/general-list-2-records/${driverId}/active-shipments`);
  },

  async syncPointsText() {
    return await apiService.get('/general-list-2-records/sync-points');
  },

  async backfillDriverLocationCache() {
    return await apiService.post('/general-list-2-records/backfill-driver-location-cache');
  },

  async getPriceMismatches(params?: { approvalStatus?: 'pending' | 'approved' | 'rejected'; includeLocked?: boolean }) {
    const queryParams = new URLSearchParams();
    if (params?.approvalStatus) queryParams.append('approvalStatus', params.approvalStatus);
    if (params?.includeLocked) queryParams.append('includeLocked', '1');
    const query = queryParams.toString();
    return await apiService.get(`/general-list-2-records/price-mismatches${query ? `?${query}` : ''}`, { timeoutMs: 300000 });
  },

  async approvePriceMismatch(shipmentId: string) {
    return await apiService.put(`/general-list-2-records/${shipmentId}/price-mismatch-approval`, { action: 'approve' });
  },

  async rejectPriceMismatch(shipmentId: string, rejectionReason: string) {
    return await apiService.put(`/general-list-2-records/${shipmentId}/price-mismatch-approval`, { action: 'reject', rejectionReason });
  },
};
